import { h } from "preact";
import styles from "./promoBannerTimer.module.css";

function PromoBannerTimer({ time, className }) {
    return (
        <div className={className}>
            {time.days !== "00" && (
                <>
                    <div className={styles.timeUnit}>
                        <span className={styles.timeValue}>{time.days}</span>
                        <span className={styles.timeLabel}>dias</span>
                    </div>
                    <span className={styles.separator}>:</span>
                </>
            )}

            <div className={styles.timeUnit}>
                <span className={styles.timeValue}>{time.hrs}</span>
                <span className={styles.timeLabel}>horas</span>
            </div>

            <span className={styles.separator}>:</span>

            <div className={styles.timeUnit}>
                <span className={styles.timeValue}>{time.mins}</span>
                <span className={styles.timeLabel}>min</span>
            </div>

            <span className={styles.separator}>:</span>

            <div className={styles.timeUnit}>
                <span className={styles.timeValue}>{time.secs}</span>
                <span className={styles.timeLabel}>seg</span>
            </div>
        </div>
    );
}

export default PromoBannerTimer;
